define('modules/video/player/video_player_view',[
  'backbone',
  'jquery',
  '_',

  './video_player_model',
  'text!./video_player_template.html',
], function (Backbone, $, _, VideoModel, video_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      if (opts.video) {
        this.model = new VideoModel();
        this.model.set(opts.video);
      }
      _.extend(this, opts);

      if (opts.hide_close_button) {
        this.model.set('hide_close_button', true);
      } else {
        this.model.set('hide_close_button', false);
      }

      this.render();
      var self = this;
      this.$video.on('play', function (e) {
        self.$el.addClass('is-playing').removeClass('is-paused');
      });
      this.$video.on('pause', function (e) {
        self.$el.addClass('is-paused').removeClass('is-playing');
      });

      this.$video.on('ended', function () {
        // ended
        self.$el.removeClass('is-playing').addClass('is-paused');
      });

      this.$video.on('progress', function (e) {
        var video = e.target;
        var buffered = video.buffered;

        if (buffered.length && video.duration) {
          self.$('.load-progress').css({
            left: (buffered.start(0) / video.duration) * 100 + '%',
            width: (buffered.end(0) / video.duration) * 100 + '%',
          });
        }
      });

      this.$video.on('canplaythrough', function () {
        self.$('.load-progress').css({
          width: '100%',
        });
      });

      this.$video.on('timeupdate', function (e) {
        var video = e.target;
        self.$('.play-progress').css({
          width: (video.currentTime / video.duration) * 100 + '%',
        });
      });
    },

    className: 'video-player is-paused',
    subViews: [],
    template: _.template(video_template),

    events: {
      'click .close': 'close',
    },

    render: function () {
      this.$el.html(this.template(this.model.toJSON()));
      this.$video = this.$('video');
      this.video = this.$video[0];

      return this;
    },

    close: function () {
      if (this.onClose) {
        this.onClose();
      }
      this.remove();
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.remove();
      this.stopListening();
      return this;
    },
  });
  return View;
});

